// **** Generated File: Do NOT edit!  **********
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClassRegistration.vm
import { Message } from "abweb/dto/Message";
import { AsyncResponse } from "abweb/dto/async/AsyncResponse";
import { PollConfiguration } from "abweb/dto/async/PollConfiguration";
import { PollResponse } from "abweb/dto/async/PollResponse";
import { VersionInfoHelper } from "abweb/dto/com/abinitio/webcommons/abweb/util/VersionInfoHelper";
import { AbstractClientRequestContext } from "abweb/dto/ds/AbstractClientRequestContext";
import { BinaryTuple } from "abweb/dto/ds/BinaryTuple";
import { ClientFieldSpec } from "abweb/dto/ds/ClientFieldSpec";
import { ClientFilterSpec } from "abweb/dto/ds/ClientFilterSpec";
import { ClientRequestContext } from "abweb/dto/ds/ClientRequestContext";
import { ClientSortSpec } from "abweb/dto/ds/ClientSortSpec";
import { ContentRestriction } from "abweb/dto/ds/ContentRestriction";
import { DataSource } from "abweb/dto/ds/DataSource";
import { DataSourceField } from "abweb/dto/ds/DataSourceField";
import { DataSourceRecord } from "abweb/dto/ds/DataSourceRecord";
import { DataSourceRecordFormat } from "abweb/dto/ds/DataSourceRecordFormat";
import { DataSourceReference } from "abweb/dto/ds/DataSourceReference";
import { DataSourceSpecInfo } from "abweb/dto/ds/DataSourceSpecInfo";
import { DataSourceValidation } from "abweb/dto/ds/DataSourceValidation";
import { DataSourceValueBinary } from "abweb/dto/ds/DataSourceValueBinary";
import { DataSourceValueBoolean } from "abweb/dto/ds/DataSourceValueBoolean";
import { DataSourceValueDate } from "abweb/dto/ds/DataSourceValueDate";
import { DataSourceValueDateTime } from "abweb/dto/ds/DataSourceValueDateTime";
import { DataSourceValueNumber } from "abweb/dto/ds/DataSourceValueNumber";
import { DataSourceValueString } from "abweb/dto/ds/DataSourceValueString";
import { DataSourceValueVector } from "abweb/dto/ds/DataSourceValueVector";
import { HistoricalPointInTime } from "abweb/dto/ds/HistoricalPointInTime";
import { ReferenceTuple } from "abweb/dto/ds/ReferenceTuple";
import { RemoteAbInitioErrorException } from "abweb/dto/exception/RemoteAbInitioErrorException";
import { DiagramResponse } from "abweb/dto/gds/DiagramResponse";
import { GraphicalClientRequestContext } from "abweb/dto/gds/GraphicalClientRequestContext";
import { GraphicalDataSource } from "abweb/dto/gds/GraphicalDataSource";
import { GraphicalDataSourceConnectionPoint } from "abweb/dto/gds/GraphicalDataSourceConnectionPoint";
import { GraphicalDataSourceEdge } from "abweb/dto/gds/GraphicalDataSourceEdge";
import { GraphicalDataSourceNode } from "abweb/dto/gds/GraphicalDataSourceNode";
import { GraphicalDataSourceObject } from "abweb/dto/gds/GraphicalDataSourceObject";
import { GraphicalDataSourceSubset } from "abweb/dto/gds/GraphicalDataSourceSubset";
import { InputArgumentSpec } from "abweb/dto/gds/InputArgumentSpec";
import { NamedDataSourceRecordReference } from "abweb/dto/gds/NamedDataSourceRecordReference";
import { Point } from "abweb/dto/gds/Point";
import { AboutInfo } from "abweb/dto/generated/about/AboutInfo";
import { AboutInfoItem } from "abweb/dto/generated/about/AboutInfoItem";
import { AsyncMessage } from "abweb/dto/generated/async/AsyncMessage";
import { AbSemanticVersionNumber } from "abweb/dto/generated/com/abinitio/sdk/commons/api/dto/AbSemanticVersionNumber";
import { AbVersionInfo } from "abweb/dto/generated/com/abinitio/sdk/commons/api/dto/AbVersionInfo";
import { DownloadStatusObject } from "abweb/dto/generated/download/DownloadStatusObject";
import { BaseIssue } from "abweb/dto/generated/genericResponse/BaseIssue";
import { ProcessResults } from "abweb/dto/generated/process/ProcessResults";
import { ProductVersion } from "abweb/dto/generated/product/ProductVersion";
import { ActivationConfiguration } from "abweb/dto/generated/session/ActivationConfiguration";
import { ActivationState } from "abweb/dto/generated/session/ActivationState";
import { ClientSessionConfiguration } from "abweb/dto/generated/session/ClientSessionConfiguration";
import { ProxyConfiguration } from "abweb/dto/generated/session/ProxyConfiguration";
import { ProxyServiceInfo } from "abweb/dto/generated/session/ProxyServiceInfo";
import { UnsavedChangesActionResponse } from "abweb/dto/generated/unsavedChangesHandler/UnsavedChangesActionResponse";
import { ChangePasswordResult } from "abweb/dto/generated/user/ChangePasswordResult";
import { LoginHistoryInfo } from "abweb/dto/generated/user/LoginHistoryInfo";
import { LoginSessionInfo } from "abweb/dto/generated/user/LoginSessionInfo";
import { UserRole } from "abweb/dto/generated/user/UserRole";
import { StringResponse } from "abweb/dto/genericResponse/StringResponse";
import { InactivityConfiguration } from "abweb/dto/inactivity/InactivityConfiguration";
import { BooleanFilterValue } from "abweb/dto/inputargs/BooleanFilterValue";
import { DateFilterValue } from "abweb/dto/inputargs/DateFilterValue";
import { FlagsFilterValue } from "abweb/dto/inputargs/FlagsFilterValue";
import { NumberFilterValue } from "abweb/dto/inputargs/NumberFilterValue";
import { ReferenceFilterValue } from "abweb/dto/inputargs/ReferenceFilterValue";
import { RelativeDateSpecifier } from "abweb/dto/inputargs/RelativeDateSpecifier";
import { StringFilterValue } from "abweb/dto/inputargs/StringFilterValue";
import { ProductInfo } from "abweb/dto/product/ProductInfo";
import { ProductInfoItem } from "abweb/dto/product/ProductInfoItem";
import { ServerProfileStats } from "abweb/dto/profile/ServerProfileStats";
import { UserInfo } from "abweb/dto/user/UserInfo";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";

/**
 * <p>Ensures that all generated classes that may be received by the client as part of a json stream are registered
 * so that they can be deserialized.  Needed so that polymorphic instances can be correctly instantiated by
 * client (as a java List<Animal> can contain lions and tigers and bears, oh my).  Note that jackson does NOT send
 * the @class attribute when the class type can be reliably inferred at compile time (e.g., 'final' classes).
 * <p>
 * Possible future enhancement: lazily load TS class on first serialized usage (dependent on module system).
 */
export class TSOGClassRegistration {
  static registerClasses() {
    TSOGUtils.registerClass("cawad.Message", Message);
    TSOGUtils.registerClass("cawada.AsyncResponse", AsyncResponse);
    TSOGUtils.registerClass("cawada.PollConfiguration", PollConfiguration);
    TSOGUtils.registerClass("cawada.PollResponse", PollResponse);
    TSOGUtils.registerClass("cawau.VersionInfoHelper", VersionInfoHelper);
    TSOGUtils.registerClass("cawadd.AbstractClientRequestContext", AbstractClientRequestContext);
    TSOGUtils.registerClass("cawadd.BinaryTuple", BinaryTuple);
    TSOGUtils.registerClass("cawadd.ClientFieldSpec", ClientFieldSpec);
    TSOGUtils.registerClass("cawadd.ClientFilterSpec", ClientFilterSpec);
    TSOGUtils.registerClass("cawadd.ClientRequestContext", ClientRequestContext);
    TSOGUtils.registerClass("cawadd.ClientSortSpec", ClientSortSpec);
    TSOGUtils.registerClass("cawadd.ContentRestriction", ContentRestriction);
    TSOGUtils.registerClass("cawadd.DataSource", DataSource);
    TSOGUtils.registerClass("cawadd.DataSourceField", DataSourceField);
    TSOGUtils.registerClass("cawadd.DataSourceRecord", DataSourceRecord);
    TSOGUtils.registerClass("cawadd.DataSourceRecordFormat", DataSourceRecordFormat);
    TSOGUtils.registerClass("cawadd.DataSourceReference", DataSourceReference);
    TSOGUtils.registerClass("cawadd.DataSourceSpecInfo", DataSourceSpecInfo);
    TSOGUtils.registerClass("cawadd.DataSourceValidation", DataSourceValidation);
    TSOGUtils.registerClass("cawadd.DataSourceValueBinary", DataSourceValueBinary);
    TSOGUtils.registerClass("cawadd.DataSourceValueBoolean", DataSourceValueBoolean);
    TSOGUtils.registerClass("cawadd.DataSourceValueDate", DataSourceValueDate);
    TSOGUtils.registerClass("cawadd.DataSourceValueDateTime", DataSourceValueDateTime);
    TSOGUtils.registerClass("cawadd.DataSourceValueNumber", DataSourceValueNumber);
    TSOGUtils.registerClass("cawadd.DataSourceValueString", DataSourceValueString);
    TSOGUtils.registerClass("cawadd.DataSourceValueVector", DataSourceValueVector);
    TSOGUtils.registerClass("cawadd.HistoricalPointInTime", HistoricalPointInTime);
    TSOGUtils.registerClass("cawadd.ReferenceTuple", ReferenceTuple);
    TSOGUtils.registerClass("cacse.RemoteAbInitioErrorException", RemoteAbInitioErrorException);
    TSOGUtils.registerClass("cawadg.DiagramResponse", DiagramResponse);
    TSOGUtils.registerClass("cawadg.GraphicalClientRequestContext", GraphicalClientRequestContext);
    TSOGUtils.registerClass("cawadg.GraphicalDataSource", GraphicalDataSource);
    TSOGUtils.registerClass("cawadg.GraphicalDataSourceConnectionPoint", GraphicalDataSourceConnectionPoint);
    TSOGUtils.registerClass("cawadg.GraphicalDataSourceEdge", GraphicalDataSourceEdge);
    TSOGUtils.registerClass("cawadg.GraphicalDataSourceNode", GraphicalDataSourceNode);
    TSOGUtils.registerClass("cawadg.GraphicalDataSourceObject", GraphicalDataSourceObject);
    TSOGUtils.registerClass("cawadg.GraphicalDataSourceSubset", GraphicalDataSourceSubset);
    TSOGUtils.registerClass("cawadg.InputArgumentSpec", InputArgumentSpec);
    TSOGUtils.registerClass("cawadg.NamedDataSourceRecordReference", NamedDataSourceRecordReference);
    TSOGUtils.registerClass("cawadg.Point", Point);
    TSOGUtils.registerClass("cawada.AboutInfo", AboutInfo);
    TSOGUtils.registerClass("cawada.AboutInfoItem", AboutInfoItem);
    TSOGUtils.registerClass("cawada.AsyncMessage", AsyncMessage);
    TSOGUtils.registerClass("cascad.AbSemanticVersionNumber", AbSemanticVersionNumber);
    TSOGUtils.registerClass("cascad.AbVersionInfo", AbVersionInfo);
    TSOGUtils.registerClass("cawadd.DownloadStatusObject", DownloadStatusObject);
    TSOGUtils.registerClass("cawadg.BaseIssue", BaseIssue);
    TSOGUtils.registerClass("cawadp.ProcessResults", ProcessResults);
    TSOGUtils.registerClass("cawadp.ProductVersion", ProductVersion);
    TSOGUtils.registerClass("cawads.ActivationConfiguration", ActivationConfiguration);
    TSOGUtils.registerClass("cawads.ActivationState", ActivationState);
    TSOGUtils.registerClass("cawads.ClientSessionConfiguration", ClientSessionConfiguration);
    TSOGUtils.registerClass("cawads.ProxyConfiguration", ProxyConfiguration);
    TSOGUtils.registerClass("cawads.ProxyServiceInfo", ProxyServiceInfo);
    TSOGUtils.registerClass("cawadu.UnsavedChangesActionResponse", UnsavedChangesActionResponse);
    TSOGUtils.registerClass("cawadu.ChangePasswordResult", ChangePasswordResult);
    TSOGUtils.registerClass("cawadu.LoginHistoryInfo", LoginHistoryInfo);
    TSOGUtils.registerClass("cawadu.LoginSessionInfo", LoginSessionInfo);
    TSOGUtils.registerClass("cawadu.UserRole", UserRole);
    TSOGUtils.registerClass("cawadg.StringResponse", StringResponse);
    TSOGUtils.registerClass("cawadi.InactivityConfiguration", InactivityConfiguration);
    TSOGUtils.registerClass("cawadi.BooleanFilterValue", BooleanFilterValue);
    TSOGUtils.registerClass("cawadi.DateFilterValue", DateFilterValue);
    TSOGUtils.registerClass("cawadi.FlagsFilterValue", FlagsFilterValue);
    TSOGUtils.registerClass("cawadi.NumberFilterValue", NumberFilterValue);
    TSOGUtils.registerClass("cawadi.ReferenceFilterValue", ReferenceFilterValue);
    TSOGUtils.registerClass("cawadi.RelativeDateSpecifier", RelativeDateSpecifier);
    TSOGUtils.registerClass("cawadi.StringFilterValue", StringFilterValue);
    TSOGUtils.registerClass("cawadp.ProductInfo", ProductInfo);
    TSOGUtils.registerClass("cawadp.ProductInfoItem", ProductInfoItem);
    TSOGUtils.registerClass("cawadp.ServerProfileStats", ServerProfileStats);
    TSOGUtils.registerClass("cawadu.UserInfo", UserInfo);
  }
}
//# sourceMappingURL=TSOGClassRegistration.js.map
